export default __webpack_public_path__ + "static/media/kp1.336bd7e1.jpg";